"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

var ResourcesService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(ResourcesService, _DAO);

  var _super = _createSuper(ResourcesService);

  function ResourcesService() {
    (0, _classCallCheck2["default"])(this, ResourcesService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ResourcesService, [{
    key: "get",

    /**
     * Get the resources shared with the user.
     * @param {Object} options - (optional) Sorting and filtering options, as listed below
     *
     *        {String} orderBy - (optional, default = "+sharedate") Field to sort on, and direction. E.g. "+sharedate"
     *                           for sorting by date shared ascending. Prefix with "-" for descending.
     *        {String[]} types - (optional) A list of mime-types to filter by. If none provided, all mimetypes will be
     *                           returned.
     * @returns {Promise}
     */
    value: function get() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$orderBy = _ref.orderBy,
          orderBy = _ref$orderBy === void 0 ? '+sharedate' : _ref$orderBy,
          _ref$types = _ref.types,
          types = _ref$types === void 0 ? [] : _ref$types,
          _ref$limit = _ref.limit,
          limit = _ref$limit === void 0 ? 10 : _ref$limit;

      var url = "".concat(this.endpoint, "/resources?orderBy=").concat(encodeURIComponent(orderBy), "&type=").concat(encodeURIComponent(types.join(',')), "&limit=").concat(limit);
      return this.getRequest({
        url: url
      });
    }
    /**
     * Get the next page of resources results, using the URL from Resources.get().
     * @param urlPath {String} URL from Resources.get(), from the _links.next property of the response.
     * @returns {Promise|*|Promise<Response>}
     */

  }, {
    key: "getNextPage",
    value: function getNextPage(urlPath) {
      return this.getRequest({
        url: urlPath
      });
    }
  }]);
  return ResourcesService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(ResourcesService, InstanceConfig);

exports["default"] = _default;